import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Angular CE for Alerts / Notifications page (Wave 2 migration).
 * Parity: page title and image from original AngularJS alerts-tpl.
 */
@Component({
    selector: 'gtw-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AlertsComponent {
  pageTitle = 'Alerts / Notifications';
}
